import { useGetBrandsByProjectId } from "@/features/brands/shared/hooks/useGetBrandsByProjectId";
import { MOCKED_BRANDS } from "@/features/templates/mocks/brands.ts";
import { useGetRequest } from "@/hooks/useGetRequest.tsx";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";

export function useGetBrands() {
  const { data: request } = useGetRequest();
  const { isTemplate } = useIsTemplate();
  const projectId = request?.projectId;

  const query = useGetBrandsByProjectId(projectId);

  if (isTemplate) {
    return {
      ...query,
      data: MOCKED_BRANDS,
    };
  }

  return query;
}
